var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"Map"},[(_vm.ready == true)?_c('GmapMap',{ref:"mapRef",style:(_vm.getStyle()),attrs:{"language":"ar","options":{
            zoomControl: false,
            fullscreenControl: false,
            center: _vm.location,
            mapTypeControl: false,
            streetViewControl: false,
            zoom: _vm.zoom,
            restriction: { latLngBounds: _vm.bounds, strictBounds: false },
            styles:[

                // {'elementType':'geometry','stylers':[{'color':'#eeeeee'}]},

                {'elementType':'labels.icon','stylers':[{'visibility':'off'}]},
                {'featureType':'transit','stylers':[{'visibility':'on'}, {'color':'#a1a1a1'}]},
                {'elementType':'labels.text.fill','stylers':[{'color':'#616161'}]},
                {'elementType':'labels.text.stroke','stylers':[{'color':'#f5f5f5'}]},
                
                {'featureType':'administrative.land_parcel','elementType':'labels.text.fill','stylers':[{'color':'#bdbdbd'}]},   

                {'featureType':'poi','elementType':'geometry','stylers':[{'color':'#d9e3dd'}]}, 
                // {'featureType':'poi','elementType':'labels.text.fill', 'stylers':[{'visibility':'off'}]},

                // {'featureType':'poi.park', 'stylers':[{'color':'#616161'}]},
                {'featureType':'poi.sports_complex', 'stylers':[{'color':'#dcdcdc'}]},

                // {'featureType':'poi.park','elementType':'labels.text.fill','stylers':[{'visibility':'off'}]},

                {'featureType':'road','elementType':'geometry','stylers':[{'color':'#ffffff'}]},
                {'featureType':'road.arterial','elementType':'labels.text.fill','stylers':[{'color':'#757575'}]},
                {'featureType':'road.highway','elementType':'geometry','stylers':[{'color':'#dadada'}]},
                {'featureType':'road.highway','elementType':'labels.text.fill','stylers':[{'color':'#616161'}]},
                {'featureType':'road.local','elementType':'labels.text.fill','stylers':[{'color':'#9e9e9e'}]},
                {'featureType':'transit.line','elementType':'geometry','stylers':[{'color':'#e5e5e5'}]},
                {'featureType':'transit.station','elementType':'geometry','stylers':[{'color':'#eeeeee'}]},

                // #dcdcdc
                {'featureType':'landscape','elementType':'geometry','stylers':[{'color':'#dcdcdc'}]},
                {'featureType':'poi.park','elementType':'geometry','stylers':[{'color':'#dcdcdc'}]},

                // #919191

                {'featureType':'water','elementType':'geometry','stylers':[{'color':'#919191'}]},
                {'featureType':'water','elementType':'labels.text.fill','stylers':[{'color':'#ffffff'}]},
                {'featureType':'road.local.trail','elementType':'geometry','stylers':[{'color':'#919191'}]}

            ]
        }}},_vm._l((_vm.markers),function(m,index){return _c('GmapMarker',{key:index,ref:'marker_'+ m.id,refInFor:true,attrs:{"position":{ lat: m.pos[0], lng: m.pos[1] },"clickable":true,"draggable":false,"icon":{ url: require('@/commons/img/'+ m.icon)}},on:{"click":function($event){return _vm.onClick(m)}}})}),1):_vm._e(),_c('transition',{attrs:{"name":"Map__button"}},[(!_vm.used)?_c('div',{staticClass:"Map__button",class:{ 'fr': _vm.lang == 'fr' },domProps:{"innerHTML":_vm._s(_vm.trans('GLOBAL.select'))}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }